<template>
  <section class="filterbar">
    <div class="frow">
      <div class="fpair">
        <span class="flabel">Bereich</span>
        <div class="seg">
          <button
            v-for="option in filters.bereiche"
            :key="option.value"
            type="button"
            class="seg__item"
            :class="{ on: selectedBereich === option.value }"
            @click="setBereich(option.value)"
          >
            {{ option.label }}
          </button>
        </div>
      </div>

      <div class="fpair">
        <span class="flabel">Marke</span>
        <SingleDropdown
          label="Marke"
          :options="filters.marken"
          :model-value="selectedMarke"
          @update:model-value="onMarkeChange"
        />
      </div>

      <div class="fpair">
        <span class="flabel">Projekt</span>
        <SingleDropdown
          label="Projekt"
          :options="filters.projekte"
          :model-value="selectedProjekt"
          @update:model-value="onProjektChange"
        />
      </div>

      <div class="fpair">
        <span class="flabel">Zeitraum</span>
        <SingleDropdown
          label="Zeitraum"
          :options="yearOptions"
          :model-value="selectedYear"
          @update:model-value="onYearChange"
        />
        <StatusLozenge tone="information" :label="`${monthLabel} ${selectedYear}`" />
      </div>

    </div>
  </section>
</template>

<script>
import SingleDropdown from './SingleDropdown.vue';
import StatusLozenge from '@/components/ui/StatusLozenge.vue';

export default {
  components: {
    SingleDropdown,
    StatusLozenge
  },
  props: {
    filters: {
      type: Object,
      required: true
    },
    selectedBereich: {
      type: String,
      required: true
    },
    selectedMarke: {
      type: String,
      required: true
    },
    selectedProjekt: {
      type: String,
      required: true
    },
    selectedYear: {
      type: Number,
      required: true
    },
    monthLabel: {
      type: String,
      required: true
    }
  },
  computed: {
    yearOptions() {
      return this.filters.years.map((year) => ({
        value: year,
        label: String(year)
      }));
    }
  },
  emits: ['update'],
  methods: {
    setBereich(value) {
      this.$emit('update', { bereich: value });
    },
    onMarkeChange(value) {
      this.$emit('update', { marke: value });
    },
    onProjektChange(value) {
      this.$emit('update', { projekt: value });
    },
    onYearChange(value) {
      this.$emit('update', { year: Number(value) });
    }
  }
};
</script>

<style scoped>
/* Toolbar im Jira-Stil: Filter-Buttons und Segment kommen aus ads.css. */
.filterbar {
  display: flex;
  align-items: center;
}

.frow {
  width: 100%;
  gap: 8px 16px;
}
</style>
